import { hasKey, isString } from "../utility/helper";
import { NaviError, NaviErrorTypes } from "../utility/navi-error";

const RegionLocales = {
  ASIA_PACIFIC: "asia-pacific", // https://www.porsche.com/pap/
  EASTERN_EUROPE: "eastern-europe", // https://www.porsche.com/central-eastern-europe/ru/ https://www.porsche.com/central-eastern-europe/en/
  MIDDLE_EAST: "middle-east", // https://www.porsche.com/middle-east/ https://www.porsche.com/middle-east/fr/
  LATIN_AMERICA: "latin-america", // https://www.porsche.com/latin-america-en/ https://www.porsche.com/latin-america-es/
  INTERNATIONAL: "international", // https://www.porsche.com/international/ -> has account
};

const RegionLocaleMap = {
  AP: RegionLocales.ASIA_PACIFIC,
  CE: RegionLocales.EASTERN_EUROPE,
  LL: RegionLocales.LATIN_AMERICA,
  WW: RegionLocales.INTERNATIONAL,
};

export function isCountryInOneOfRegions(country: string): boolean {
  return Object.values<string>(RegionLocales).includes(country);
}

export function splitLocale(localeStr: string): Locale {
  if (!isString(localeStr)) {
    throw new NaviError("empty locale passed", NaviErrorTypes.NO_INPUT);
  }

  if (localeStr === "en") {
    return {
      language: "en",
      country: RegionLocales.INTERNATIONAL,
    };
  }

  const language = localeStr.substring(0, localeStr.indexOf("-")).toLowerCase();
  let country = localeStr.substring(localeStr.indexOf("-") + 1).toLowerCase();

  if (!isCountryInOneOfRegions(country)) {
    country = country.toUpperCase();
  }

  if (!isString(language) || !isString(country)) {
    throw new NaviError(
      `invalid locale ${localeStr} passed`,
      NaviErrorTypes.INVALID_INPUT,
    );
  }

  return {
    language,
    country: hasKey(RegionLocaleMap, country)
      ? RegionLocaleMap[country]
      : country,
  };
}

export class Locale {
  language: string;

  country: string;

  constructor(language: string, country: string) {
    this.language = language;
    this.country = country;
  }

  static parse(localeStr: string): Locale {
    const { language, country } = splitLocale(localeStr);
    return new Locale(language, country);
  }

  static isRegionalMarket(country: string): boolean {
    return Object.values<string>(RegionLocales).includes(country);
  }

  toString(): string {
    return `${this.language}-${this.country}`;
  }
}
